import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

const Fullstack = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
  return (
    <>
      <Helmet>
        <title>Full stack</title>
      </Helmet>
      <div className="navigationssections-all">
        <div className="topblur-image">
          <img
            className="righttop-blur"
            src="/images/right-top.png"
            alt="no-data"
          />
        </div>
        <div className="leftblur-image">
          <img className="left-blur" src="/images/left.png" alt="no-data" />
        </div>
        <div className="rightblur-image">
          <img className="right-blur" src="/images/right.png" alt="no-data" />
        </div>
        {/* Native Payment Solutions */}
        <div className="NativePaymentSolutions">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <h1 className="mainhead">Full stack development</h1>
                <p className="mainsubtxt">
                  Hire dedicated full stack developers who understand your
                  business requirements and develop scalable solutions.
                </p>
                <div className="text-center">
                  <NavLink to={"/contact-us"} className="clickbtn">
                    Talk to our Team
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="NativePaymentsection4">
          <div className="container">
            <h2 className="nativepayment4head nativepayment4head3">
              Our Development Process for Fixed-Bid and Dedicated Team Model
            </h2>
            <p className="ourblockchain">
              We follow an agile development methodology to pace up the software
              delivery process. Using agile development, we perform daily scrum
              activities to plan and track the progress of the project. Our team
              conducts sprint retrospective regularly where our team and the
              project owner review the just-concluded sprint and discuss the
              changes to be made. We do continuous integration so that errors
              could be detected and removed quickly.
            </p>
            <p className="ourblockchain">
              Following continuous testing, we ensure to test the software at
              every step of the continuous delivery process. We develop the
              custom digital solution on time and reduce the time to market with
              agile method adoption.
            </p>
          </div>
        </div>
        <div className="NativePaymentsection4">
          <div className="container">
            <h2 className="nativepayment4head">
              Why hire Full Stack Developer?
            </h2>
            <p className="ourblockchain">
              With knowledge and experience of front-end and back-end
              technologies, our full-stack developers can work in diverse
              business domains. We have a team of 100+ full stack developers who
              can develop the web app, mobile app and desktop app from scratch,
              tailored to the needs of a client.
            </p>
            <p className="ourblockchain">
              We create interactive UI/UX designs for smooth and easier user
              experience. Our high fidelity design helps business to visualize
              the system before it goes into the development.
            </p>
            <div className="row">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box14">
                  <h6 className="nativepayment4boxtxt">Web Innovation</h6>
                  <p className="nativepayment4boxtxt2">
                    Innovations from web portals to mobile apps
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box14">
                  <h6 className="nativepayment4boxtxt">Strategic UI/UX</h6>
                  <p className="nativepayment4boxtxt2">
                    Tech inspired UI/UX design company giving vital web
                    interfaces
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box14">
                  <h6 className="nativepayment4boxtxt">Agile UX</h6>
                  <p className="nativepayment4boxtxt2">
                    Working with Agile methodology to deliver a superior user
                    experience
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="NativePaymentsection4">
          <div className="container">
            <h2 className="nativepayment4head">Front End Development</h2>
            <h6 className="nativepayment4boxtxt">
              We emphasize on Design-Centric Front End Development.
            </h6>
            <p className="ourblockchain">
              Progressive web and native development for Enterprises. Leveraging
              the flexibility in designing creating dynamic web experiences, we
              deliver the high-end web architecture development for their
              enterprise clients.
            </p>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box7">
                  <h6 className="nativepayment4boxtxt">BootStrap</h6>
                  <p className="nativepayment4boxtxt2">
                    We use BootStrap to build responsive websites. Its
                    open-source toolkit enables developers to develop a website
                    with HTML, JS and CSS.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box7">
                  <h6 className="nativepayment4boxtxt">Angular.js</h6>
                  <p className="nativepayment4boxtxt2">
                    We use Angular.js, a feature-packed Javascript Framework, to
                    simplify the development of dynamic and web apps.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box7">
                  <h6 className="nativepayment4boxtxt">React</h6>
                  <p className="nativepayment4boxtxt2">
                    To provide cross-platform app development services, we use
                    React Native as it supports the development of apps on
                    Android and iOS with the same codebase.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box7">
                  <h6 className="nativepayment4boxtxt">jQuery</h6>
                  <p className="nativepayment4boxtxt2">
                    We utilize jQuery library to use an abundance of plugins on
                    the web to create special effects.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="nativepayment4box nativepayment4box15">
                  <h6
                    className="nativepayment4boxtxt"
                    style={{ textAlign: "center" }}
                  >
                    Full-fledged Web API Development Services
                  </h6>
                  <p
                    className="nativepayment4boxtxt2"
                    style={{ textAlign: "center" }}
                  >
                    We provide complete Web API Development Services with owned
                    or 3rd Party Integrations to run applications quickly. Some
                    core use cases include iOT devices, B2B Integrations and
                    SaaS platforms.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box7">
                  <h6 className="nativepayment4boxtxt">Node.js</h6>
                  <p className="nativepayment4boxtxt2">
                    We build multi-user real-time web applications that perform
                    at lightning speed using node.js
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box7">
                  <h6 className="nativepayment4boxtxt">PHP</h6>
                  <p className="nativepayment4boxtxt2">
                    Our PHP developers avail benefits of the scripting
                    language’s ability to construct high-performance server
                    backends and dynamic web pages.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="NativePaymentsection4">
          <div className="container">
            <h2 className="nativepayment4head">Back End Development</h2>
            <h6 className="nativepayment4boxtxt">
              Developing secure Backend Architecture
            </h6>
            <p className="ourblockchain">
              Building stable server backends to fetch data from multiple points
              and compile them under a single web interface. We assure you to
              offer highly secure backend solutions that meet the standards of
              your project.
            </p>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">Java</h6>
                  <p className="nativepayment4boxtxt2">
                    Using Java, we create write once and run everywhere
                    server-side applications.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">Spring</h6>
                  <p className="nativepayment4boxtxt2">
                    Our Web Developers build Java applications to add more power
                    to web applications with open-source and highly extensible
                    Java framework called Spring.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="nativepayment4box nativepayment4box15">
                  <h6
                    className="nativepayment4boxtxt"
                    style={{ textAlign: "center" }}
                  >
                    Cloud Hosting
                  </h6>
                  <p
                    className="nativepayment4boxtxt2"
                    style={{ textAlign: "center" }}
                  >
                    High-performance cloud platforms to build, deploy and manage
                    enterprise applications We have deployed &amp; managed
                    enterprise applications on cloud hosting with elastic
                    scalability perfect for object storage. We manage and deploy
                    enterprise applications on cloud platforms with elastic
                    scalability for object storage.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">AWS</h6>
                  <p className="nativepayment4boxtxt2">
                    Offering a broader set of global compute storage, analytics,
                    database, application and deployment services, we use AWS to
                    host scalable and robust applications.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">Microsoft Azure</h6>
                  <p className="nativepayment4boxtxt2">
                    Our developers build, test, deploy and manage applications
                    and services via a global network of Microsoft Azure, which
                    is an enterprise-grade cloud computing platform with IaaS,
                    SaaS, PaaS models.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">
                    Google Cloud Platform
                  </h6>
                  <p className="nativepayment4boxtxt2">
                    Since Google Cloud Platform has a unique feature,
                    “Pay-as-you-go we help organizations save money by paying
                    for services according to their needs.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">Firebase</h6>
                  <p className="nativepayment4boxtxt2">
                    Using a real-time database, Firebase, we ensure that the
                    cloud-based applications are always synchronized.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="NativePaymentsection4">
          <div className="container">
            <h2 className="nativepayment4head">DevOps</h2>
            <p className="ourblockchain">
              Accelerating the product release cycle time with improved
              efficiency During our DevOps Agile Cycle, the Testing Team picks
              up the Jira Issues to conduct the scrum daily. After the
              resolution of issues, the Code Repo triggers the commit code into
              the Jenkins in three states, i.e., Jenkins QA, Jenkins UAT,
              Jenkins Prod. Once the code is committed, Hockeyapp and the AWS
              continuously delivers the build for testing through the
              provisionary tools.
            </p>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">AML/KYC</h6>
                  <p className="nativepayment4boxtxt2">
                    We can implement AML/KYC service in the digital solutions to
                    ensure additional security and protect against financial
                    frauds.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">PCI DSS</h6>
                  <p className="nativepayment4boxtxt2">
                    Our Full Stack Developer team understands the PCI compliance
                    and meets its requirements while building solutions that
                    deal with financial transactions.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">HIPAA</h6>
                  <p className="nativepayment4boxtxt2">
                    Our team of full-stack developers understands the privacy of
                    health records and therefore, we ensure that healthcare
                    solutions comply with HIPAA standards.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="nativepayment4box nativepayment4box4">
                  <h6 className="nativepayment4boxtxt">GDPR</h6>
                  <p className="nativepayment4boxtxt2">
                    We make apps, websites, or platforms GDPR ready to protect
                    the personal information of users like mailing address,
                    product purchases, IP address and payment information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Web3GameDevelopment">
          <div className="container">
            <div className="row">
              <div className="col-md-10">
                <div className="Web3GameDevelopment-sec">
                  <h2 className="Web3GameDevelopmentHead">
                    Tell Us About Your Challenge &amp; Get a Free Strategy
                    Session
                  </h2>
                  <p className="Web3GameDevelopmentxt Web3GameDevelopmentxt2">
                    Create futuristic, next-gen products with CST 3.0 and
                    confidently bring your ideas to life with our experienced
                    development team. Avail our super-friendly support to help
                    you manage and scale any Web2/Web3 products seamlessly.
                  </p>
                  <NavLink to={"/contact-us"} className="cntbt">
                    Contact us
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Fullstack;
